import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// actions
import { updateUser } from '../../../actions/user';

// components
import OverlayLoader from '../../../parts/OverlayLoader';

class _PhoneNumEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      phoneNumber: this.props.phoneNumber.number,
      loadState: false,
      maxLength: 12,
      error: false,
      validNumber: true
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePhoneNumberChange = this.handlePhoneNumberChange.bind(this);
    this.handleUpdateFail = this.handleUpdateFail.bind(this);
    this.closeForm = this.closeForm.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    const { updateUser, phoneNumber } = this.props;
    const newNumber = this.state.phoneNumber.replace(' ', '');
    const containsProhibited = new RegExp(/[^0-9]/, 'g').test(newNumber);

    if (containsProhibited || !newNumber.length) {
      return this.setState({ validNumber: false });
    }

    this.setState({ loadState: true, error: false, validNumber: true });

    const newNumberObj = { ...phoneNumber, number: newNumber };
    const userData = { phoneNumbers: [newNumberObj] };

    return updateUser(userData).then((res) => {
      if (!res) return Promise.reject();
      return this.setState({ active: false, loadState: false, error: false });
    })
      .catch(this.handleUpdateFail);
  }

  handleUpdateFail() {
    this.setState({ loadState: false, error: true });
  }

  handlePhoneNumberChange(event) {
    if (event.target.value.length > this.state.maxLength) {
      return;
    }
    this.setState({ phoneNumber: this.phoneNumberInput.value });
  }

  closeForm() {
    this.setState({
      active: false,
      error: false,
      loading: false,
      phoneNumber: this.props.phoneNumber.number
    });
  }

  render() {
    const { active, phoneNumber, loadState, error, validNumber } = this.state;
    if (active) {
      return (
        <div className="u-position-relative">

          <OverlayLoader
            active={loadState}
            background={'rgba(247, 247, 247, .8)'}
          />

          <form
            className="u-w-100 u-padding-top-tiny"
            onSubmit={this.handleSubmit}
            method="post"
          >
            <fieldset className="floating-label">

              <input
                id="phoneNumber"
                type="tel"
                value={phoneNumber}
                ref={(phoneNumberInput) => { this.phoneNumberInput = phoneNumberInput; }}
                onChange={this.handlePhoneNumberChange}
                required
              />

              <label htmlFor="phoneNumber">Phone number</label>

              <section className="cta__controls">

                <button
                  className="c-btn c-btn--link"
                  disabled={phoneNumber.replace(/[^0-9+]/, '') === this.props.phoneNumber.number.replace(/[^0-9+]/, '')}
                  onClick={this.handleSubmit}
                >
                  save
                </button>

                <button
                  className="c-btn c-btn--link"
                  onClick={this.closeForm}
                >
                  cancel
                </button>

              </section>

            </fieldset>
            {error ? <div className="errors">Sorry, we couldnt update your number</div> : null}
            {validNumber ? null : <div className="errors">Please enter a valid number</div>}
          </form>

        </div>
      );
    }

    return (
      <button
        className="u-pull-right c-btn c-btn--link"
        tabIndex="0"
        onClick={() => this.setState({ active: true })}
      >
        Edit
      </button>
    );
  }


}

const mapDispatchToProps = dispatch => bindActionCreators({
  updateUser
}, dispatch);

export default connect(null, mapDispatchToProps)(_PhoneNumEditor);



// WEBPACK FOOTER //
// ./src/cards/templates/UserDetailsCard/PhoneNumEditor.js